// extracted by mini-css-extract-plugin
module.exports = {"title":"_DocumentsListItem_title__3hI0-","date":"_DocumentsListItem_date__2I2Hu"};